import { factoredInteger } from './util';

/**
 * 파레트(빈) 컨테이너. 치수는 factoredInteger(×1e5) 정수로 저장한다.
 * 실제 배치 로직은 EMS 코어(ems.js)와 v5 폴백(Packer.js)에서 수행하며,
 * 이 클래스는 크기/무게/배치결과(items)만 보관한다.
 *
 * 6번째 인자(과거 코드의 잔재)는 무시한다 — 계약 유지를 위해 시그니처만 받는다.
 */
export default class Bin {

  constructor(name, w, h, d, mw) {
    this.name = name;
    this.width = factoredInteger(w);
    this.height = factoredInteger(h);
    this.depth = factoredInteger(d);
    this.maxWeight = factoredInteger(mw);
    this.items = [];
  }

  getName() { return this.name; }
  getWidth() { return this.width; }
  getHeight() { return this.height; }
  getDepth() { return this.depth; }
  getMaxWeight() { return this.maxWeight; }
  getItems() { return this.items; }

  getVolume() {
    return this.getWidth() * this.getHeight() * this.getDepth();
  }

  getPackedWeight() {
    return this.items.reduce((weight, item) => weight + item.getWeight(), 0);
  }

  weighItem(item) {
    const maxWeight = this.getMaxWeight();
    return !maxWeight || (item.getWeight() + this.getPackedWeight() <= maxWeight);
  }

  toString() {
    return `Bin:${this.name} (WxHxD = ${this.getWidth()}x${this.getHeight()}x${this.getDepth()}, MaxWg. = ${this.getMaxWeight()})`;
  }
}
